class AccordionGrid extends HTMLElement {
  connectedCallback() {
    const sectionId = this.dataset.zendeskSection
    if (sectionId) {
      this.fetchArticles(sectionId)
    } else {
      this.bindToggles()
    }
  }

  bindToggles() {
    this.items = this.querySelectorAll('.accordion-grid-item')
    this.items.forEach((item) => {
      item.addEventListener('toggle', this.handleToggle.bind(this))
    })
  }

  handleToggle(event) {
    const opened = event.target
    if (!opened.open) return

    this.items.forEach((item) => {
      if (item !== opened && item.open) {
        item.open = false
      }
    })
  }

  async fetchArticles(sectionId) {
    const container = this.querySelector('.accordion-grid-items')
    if (!container) return

    try {
      const res = await fetch(
        `/apps/api/articles?section_id=${encodeURIComponent(sectionId)}`
      )
      if (!res.ok) throw new Error(`${res.status}`)

      const articles = await res.json()
      container.innerHTML = articles
        .map(
          (a) => `
        <details class="accordion-grid-item">
          <summary class="accordion-grid-header">
            <span class="accordion-grid-question">${this.escapeHtml(a.title)}</span>
            <span class="accordion-grid-icon" aria-hidden="true"></span>
          </summary>
          <div class="accordion-grid-body">
            <div class="accordion-grid-answer">${a.body}</div>
          </div>
        </details>`
        )
        .join('')

      this.bindToggles()
    } catch (err) {
      console.error('Failed to load Zendesk articles:', err)
      container.innerHTML =
        '<p class="accordion-grid-error">Unable to load FAQ content.</p>'
    }
  }

  escapeHtml(str) {
    const el = document.createElement('span')
    el.textContent = str
    return el.innerHTML
  }
}

customElements.define('accordion-grid', AccordionGrid)
